<template>
  <ElForm inline class="transactions-search" @submit.native.prevent="search">
    <ElFormItem>
      <ElInput
        v-model="token"
        name="token"
        :placeholder="$t('APP.TRANSACTIONS.PURCHASES_TOKEN')"
      />
    </ElFormItem>
    <ElFormItem>
      <ElButton type="primary" native-type="submit">
        {{ $t('APP.TRANSACTIONS.FILTER_RESULT') }}
      </ElButton>
    </ElFormItem>

    <ErrorsList v-if="errors" :errors="errors" />
  </ElForm>
</template>

<script>
import ErrorsList from '@@/common/ErrorsList';
export default {
  name: 'TransactionsPurchasesSearch',

  components: {
    ErrorsList,
  },

  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      token: '',
    };
  },

  methods: {
    search() {
      this.$emit('search', this.token);
    },
  },
};
</script>

<style lang="scss">
.transactions-search {
  .el-form-item {
    margin-top: $global-margin / 2;
    margin-bottom: $global-margin / 2;
  }

  .errors-box {
    margin: 0 $global-margin;
  }

  input {
    font-family: $lb-body-en-font-family;
  }
}
</style>
